
export const dataCategory = [
  {
    name: 'Automotive',
    value: 'AUTO'
  },
  {
    name: 'Beauty, spa and salon',
    value: 'BEAUTY'
  },
  {
    name: 'Clothing',
    value: 'APPAREL'
  },
  {
    name: 'Education',
    value: 'EDU'
  },
  {
    name: 'Entertainment',
    value: 'ENTERTAIN'
  },
  {
    name: 'Event planning and service',
    value: 'EVENT_PLAN'
  },
  {
    name: 'Finance and banking',
    value: 'FINANCE'
  },
  {
    name: 'Food and groceries',
    value: 'GROCERY'
  },
  {
    name: 'Public service',
    value: 'GOVT'
  },
  {
    name: 'Hotel and lodging',
    value: 'HOTEL'
  },
  {
    name: 'Medical and health',
    value: 'HEALTH'
  },
  {
    name: 'Charity',
    value: 'NONPROFIT'
  },
  {
    name: 'Professional services',
    value: 'PROF_SERVICES'
  },
  {
    name: 'Shopping and retail',
    value: 'RETAIL'
  },
  {
    name: 'Travel and transportation',
    value: 'TRAVEL'
  },
  {
    name: 'Restaurant',
    value: 'RESTAURANT'
  },
  // {
  //   name: 'NOT_A_BIZ',
  //   value: 'NOT_A_BIZ'
  // },
  {
    name: 'OTHER',
    value: 'OTHER'
  },
];

export const DefaultDate = [
  {
    name: 'Last 7 days',
    value: 'Last 7 days',
  },
  {
    name: 'Last 30 days',
    value: 'Last 30 days',
  },
  {
    name: 'Last 60 days',
    value: 'Last 60 days',
  },
  {
    name: 'Last 90 days',
    value: 'Last 90 days',
  },
]

export const dataTable = [
  {
    id: 1,
    templateName: 'sample_announcement_2023',
    category: 'Marketing',
    language: 'English (US)',
    descLanguage : 'This is your message overview',
    status: 'InReview',
    totalSent: 3663,
    totalOpened: 3663,
    lastUpdated: '08 Jan 2022, 12:45 '
  },
  {
    id: 2,
    templateName: 'ample_announcement_2023',
    category: 'Marketing',
    language: 'English (US)',
    descLanguage : 'This is your message overview',
    status: 'Requested',
    totalSent: 213,
    totalOpened: 3663,
    lastUpdated: '08 Jan 2022, 12:45 ',
  },
  {
    id: 3,
    templateName: 'mple_announcement_2023',
    category: 'Marketing',
    language: 'English (US)',
    descLanguage : 'This is your message overview',
    status: 'Active',
    totalSent: 8263,
    totalOpened: 4663,
    lastUpdated: '08 Jan 2022, 12:45 ',
  },
  {
    id: 4,
    templateName: 'ple_announcement_2023',
    category: 'Marketing',
    language: 'English (US)',
    descLanguage : 'This is your message overview',
    status: 'Rejected',
    totalSent: 5663,
    totalOpened: 1663,
    lastUpdated: '08 Jan 2022, 12:45 ',
  },
  {
    id: 5,
    templateName: 'le_announcement_2023',
    category: 'Marketing',
    language: 'English (US)',
    descLanguage : 'This is your message overview',
    status: 'active-low',
    totalSent: 3163,
    totalOpened: 2662,
    lastUpdated: '08 Jan 2022, 12:45 ',
  },
  {
    id: 6,
    templateName: 'e_announcement_2023',
    category: 'Marketing',
    language: 'English (US)',
    descLanguage : 'This is your message overview',
    status: 'paused',
    totalSent: 2663,
    totalOpened: 263,
    lastUpdated: '08 Jan 2022, 12:45 ',
  },
]

export const ListDropdownCategory =[
  {
    name: 'Authentication',
    value: 'AUTHENTICATION'
  },
  {
    name: 'Marketing',
    value: 'MARKETING'
  },
  {
    name: 'Utility',
    value: 'UTILITY'
  }
]

export const categoryTemplate = [
  {
    name: 'Marketing',
    description: 'Send promotions and information about your products, services or business',
    value: 'MARKETING'
  },
  {
    name: 'Utility',
    description: 'Send messages about an existing order or account',
    value: 'UTILITY'
  },
  {
    name: 'Authentication',
    description: 'Send codes to verify a transaction or login',
    value: 'AUTHENTICATION'
  },
]

export const opsiHeader = [
  {
    name: "None",
    value: "NONE",
  },
  {
    name: "Media",
    value: "MEDIA",
  },
  {
    name: "Text",
    value: "TEXT",
  },
];

export const opsiButton = [
  {
    name: "None",
    value: "none",
  },
  {
    name: "Quick Reply",
    value: "quick_reply",
  },
  {
    name: "Call To Action",
    value: "call_to_action",
  },
];

export const TypeCTA = [
  {
    disable: false,
    name: "Call phone number",
    value: "call_phone_number",
  },
  {
    disable: false,
    name: "Visit Web",
    value: "visit_web",
  },
];

export const TypeQuickReply = [
  // {
  //   name: "Marketing opt-out",
  //   value: "marketing-opt-out",
  // },
  {
    name: "Custom",
    value: "custom",
  },
];

export const UrlTypeCTA = [
  {
    name: "Static",
    value: "static",
  },
  {
    name: "Dynamic",
    value: "dynamic",
  },
];

export const ListCategory = [
  {
    name: "Marketing",
    value: "marketing",
  },
  {
    name: "Dynamic",
    value: "dynamic",
  },
];

export const ListDropdownStatus = [
  {
    name: "In review",
    value: "PENDING",
    checked: true
  },
  {
    name: "Rejected",
    value: "REJECTED",
    checked: true
  },
  {
    name: "Active",
    value: "APPROVED",
    checked: true
  },
  {
    name: "Paused",
    value: "PAUSED",
    checked: true
  },
  {
    name: "Disabled",
    value: "DISABLED",
    checked: true
  },
  {
    name: "Appeal Requestedy",
    value: "IN_APPEAL",
    checked: true
  }
];

export const listLanguage = [
  {
    name: 'Afrikaans',
    value: 'af'
  },
  {
    name: 'Albanian',
    value: 'sq'
  },
  {
    name: 'Arabic',
    value: 'ar'
  },
  {
    name: 'Azerbaijani',
    value: 'az'
  },
  {
    name: 'Bengali',
    value: 'bn'
  },
  {
    name: 'Bulgarian',
    value: 'bg'
  },
  {
    name: 'Catalan',
    value: 'ca'
  },
  {
    name: 'Chinese (CHN)',
    value: 'zh_CN'
  },
  {
    name: 'Chinese (HKG)',
    value: 'zh_HK'
  },
  {
    name: 'Chinese (TAI)',
    value: 'zh_TW'
  },
  {
    name: 'Croatian',
    value: 'hr'
  },
  {
    name: 'Czech',
    value: 'cs'
  },
  {
    name: 'Danish',
    value: 'da'
  },
  {
    name: 'Dutch',
    value: 'nl'
  },
  {
    name: 'English',
    value: 'en'
  },
  {
    name: 'English (UK)',
    value: 'en_GB'
  },
  {
    name: 'English (US)',
    value: 'en_US'
  },
  {
    name: 'Estonian',
    value: 'et'
  },
  {
    name: 'Filipino',
    value: 'fil'
  },
  {
    name: 'Finnish',
    value: 'fi'
  },
  {
    name: 'French',
    value: 'fr'
  },
  {
    name: 'German',
    value: 'de'
  },
  {
    name: 'Greek',
    value: 'el'
  },
  {
    name: 'Gujarati',
    value: 'gu'
  },
  {
    name: 'Hausa',
    value: 'ha'
  },
  {
    name: 'Hebrew',
    value: 'he'
  },
  {
    name: 'Hindi',
    value: 'hi'
  },
  {
    name: 'Hungarian',
    value: 'hu'
  },
  {
    name: 'Indonesian',
    value: 'id'
  },
  {
    name: 'Irish',
    value: 'ga'
  },
  {
    name: 'Italian',
    value: 'it'
  },
  {
    name: 'Japanese',
    value: 'ja'
  },
  {
    name: 'Kannada',
    value: 'kn'
  },
  {
    name: 'Kazakh',
    value: 'kk'
  },
  {
    name: 'Korean',
    value: 'ko'
  },
  {
    name: 'Kyrgyz (Kyrgyzstan)',
    value: 'ky_KG'
  },
  {
    name: 'Lao',
    value: 'lo'
  },
  {
    name: 'Latvian',
    value: 'lv'
  },
  {
    name: 'Lithuanian',
    value: 'lt'
  },
  {
    name: 'Macedonian',
    value: 'mk'
  },
  {
    name: 'Malay',
    value: 'ms'
  },
  {
    name: 'Malayalam',
    value: 'ml'
  },
  {
    name: 'Marathi',
    value: 'mr'
  },
  {
    name: 'Norwegian',
    value: 'nb'
  },
  {
    name: 'Persian',
    value: 'fa'
  },
  {
    name: 'Polis',
    value: 'pl'
  },
  {
    name: 'Portuguese (BR)',
    value: 'pt_BR'
  },
  {
    name: 'Portuguese (POR)',
    value: 'pt_PT'
  },
  {
    name: 'Punjabi',
    value: 'pa'
  },
  // {
  //   name: 'Rumania',
  //   value: 'ro'
  // },
  // {
  //   name: 'Rusia',
  //   value: 'ru'
  // },
  // {
  //   name: 'Serbia',
  //   value: 'sr'
  // },
  // {
  //   name: 'Slowakia',
  //   value: 'sk'
  // },
  // {
  //   name: 'Slovenia',
  //   value: 'sl'
  // },
  // {
  //   name: 'Spanyol',
  //   value: 'es'
  // },
  // {
  //   name: 'Spanyol (ARG)',
  //   value: 'es_AR'
  // },
  // {
  //   name: 'Spanyol (SPA)',
  //   value: 'es_ES'
  // },
  // {
  //   name: 'Spanyol (MEX)',
  //   value: 'es_MX'
  // },
  // {
  //   name: 'Swahili',
  //   value: 'sw'
  // },
  // {
  //   name: 'Swedia',
  //   value: 'sv'
  // },
  // {
  //   name: 'Tamil',
  //   value: 'ta'
  // },
  // {
  //   name: 'Telugu',
  //   value: 'te'
  // },
  // {
  //   name: 'Thai',
  //   value: 'th'
  // },
  // {
  //   name: 'Turki',
  //   value: 'tr'
  // },
  // {
  //   name: 'Ukraina',
  //   value: 'uk'
  // },
  // {
  //   name: 'Urdu',
  //   value: 'ur'
  // },
  // {
  //   name: 'Uzbek',
  //   value: 'uz'
  // },
  // {
  //   name: 'Vietnam',
  //   value: 'vi'
  // },
  // {
  //   name: 'Zulu',
  //   value: 'zu'
  // },
]